import { msalInstance } from '../../App';

export class InboundActivityService {

    async invokeWebAPI(url, httpMethod, msalContext, body = "", rawResponse = false) {

        // check if msalContext exists
        if (msalContext.accounts.length > 0) {
            const tokenRequest = {
                scopes: [global.ENV_MSAL_LOGIN_REQUEST_SCOPES],
                account: msalContext.accounts[0],
            };

            // acquire Bearer token to include in GET request
            const tokenResponse = await msalInstance.acquireTokenSilent(tokenRequest);
            const token = tokenResponse.accessToken;
            const bearer = `Bearer ${token}`;
            const headers = new Headers();
            headers.append('Accept', '*/*');
            headers.append('Content-Type', 'application/json');
            headers.append('x-northwell-version', '1.0');
            headers.append("Authorization", bearer);
            headers.append('User', msalContext.accounts[0].username)

            var options = {}
            if (body) {
                options = {
                    method: httpMethod,
                    headers: headers,
                    body: body
                };
            }
            else {
                options = {
                    method: httpMethod,
                    headers: headers
                };
            }

            let response = await fetch(url, options);

            if (rawResponse)
                return response;
            else
                return {
                    status: response.status,
                    body: await response.json()
                };

        } else {
            console.log('user not logged in')
        }
    }

    async getInboundData(instance, nameSpace, interfaceName, LastInboundTimeStamp, LastInboundTimeStampCondition, msalContext) {

        let url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/inboundmetric/v1?FilterByDNMList=true"
        if (instance)
            url = url + "&Instance=" + instance
        if (nameSpace)
            url = url + "&nameSpace=" + nameSpace
        if (interfaceName)
            url = url + "&InterfaceName=" + encodeURIComponent(interfaceName)
        if (LastInboundTimeStamp)
            url = url + "&LastInboundTimeStamp=" + LastInboundTimeStamp
        if (LastInboundTimeStampCondition)
            url = url + "&LastInboundTimeStampCondition=" + LastInboundTimeStampCondition
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getInboundDataV2(instance, nameSpace, interfaceName, LastInboundTimeStamp, LastInboundTimeStampCondition, msalContext) {

        let url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/inboundmetric/v2?LookbackTime=360&FilterByDNMList=true"
        if (instance)
            url = url + "&Instance=" + instance
        if (nameSpace)
            url = url + "&nameSpace=" + nameSpace
        if (interfaceName)
            url = url + "&InterfaceName=" + encodeURIComponent(interfaceName)
        if (LastInboundTimeStamp)
            url = url + "&LastInboundTimeStamp=" + LastInboundTimeStamp
        if (LastInboundTimeStampCondition)
            url = url + "&LastInboundTimeStampCondition=" + LastInboundTimeStampCondition
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async exportInboundDataV2(instance, nameSpace, interfaceName, LastInboundTimeStamp, LastInboundTimeStampCondition, msalContext) {

        let url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/inboundmetric/v2/export?LookbackTime=360&FilterByDNMList=true"
        if (instance)
            url = url + "&Instance=" + instance
        if (nameSpace)
            url = url + "&nameSpace=" + nameSpace
        if (interfaceName)
            url = url + "&InterfaceName=" + encodeURIComponent(interfaceName)
        if (LastInboundTimeStamp)
            url = url + "&LastInboundTimeStamp=" + LastInboundTimeStamp
        if (LastInboundTimeStampCondition)
            url = url + "&LastInboundTimeStampCondition=" + LastInboundTimeStampCondition
        try {
            const response = await this.invokeWebAPI(url, 'POST', msalContext, true);
            return response;
        }
        catch (e) {
            console.log(e);
        }
    }

    async getInboundDataById(Id, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/inboundmetric/" + Id
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async editInboundDataById(Id, msalContext, body) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/inboundmetric/" + Id
        try {
            const response = await this.invokeWebAPI(url, 'PUT', msalContext, body);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getInboundMetricUpdatelogs(Id, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/inboundmetric/" + Id + "/auditlogs"
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    //HM-938 - Bulk update in case of Inbound In-Activity page.
    async editMiltupleInboundData(msalContext, body) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/inboundmetric/multiple"
        try {
            const response = await this.invokeWebAPI(url, 'PUT', msalContext, body);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getMetricThresholdByLatestId(msalContext, LatestRecordId) {
        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/MetricsRead/threshold/" + LatestRecordId;
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }
}